import { useContext } from 'react'
import styled from 'styled-components'
import { transform } from 'ol/proj'

import CogIcon from '../icons/CogIcon'
import SaveIcon from '../icons/SaveIcon'

import NotesContext from '../context/NotesContext'

import Location from './Location'

const Table = styled.div`
  display: table;
  padding: 1em;
`
const TableRow = styled.div`
  display: table-row;
`
const TableCell = styled.div`
  display: table-cell;
  text-align: left;
`
const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 20%;
  padding: 0.8rem;
`
const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex: 0;
  background-color: lightgrey;
`
const BlueSpan = styled.span`
  color: blue;
`

export default function PartialResults({
  coordinates,
  mapUnits,
  queryType,
  queryData,
  onMoreClick,
  onSettingsClick,
  goToNote,
}) {

  const { notes, setNotes, noteStore } = useContext(NotesContext);

  const createNoteText = (queryData) => {
    let text = "\r\n";
    if (queryData && queryData.attributes) {
      const keys = Object.keys(queryData.attributes);
      keys.forEach((key, i) => {
        const value = (queryData.attributes[key]) ? queryData.attributes[key] : '';
        text += "\r\n" + key + ": " + value;
      });

    }
    text += "\r\n\r\n";
    return text;
  }

  const saveClickHandler = () => {
    //console.error('saveClickHandler *******************');
    //console.log(queryData);
    //console.log(coordinates);
    // TODO: add coordinates and queryData to a new note

    const point4326 = transform(coordinates, 'EPSG:2264', 'EPSG:4326');

    let newNote = {
      latitude: point4326[1],
      longitude: point4326[0],
      x: coordinates[0],
      y: coordinates[1],
      title: '',
      text: '',
      checked: false,
    }
    if (queryData) {
      newNote.title = queryData.id;
      newNote.text = createNoteText(queryData);
    }
    //console.log(newNote);

    const [newNotes, id] = noteStore.addNote(notes, newNote);
    //console.log(newNotes);
    //console.log(id);
    setNotes(newNotes);
    goToNote(id);
  }

  //console.error('rendering PartialResults ************************');

  let data;
  if (queryData && queryData.attributes) {
    //console.log(queryData);
    //console.log(queryType);
    const noParcel = queryData.attributes.hasOwnProperty('rightlow');;
    //console.log(noParcel);
    switch (queryType) {
      case 'multiple-layers':  // fall through on purpose
      case 'single-parcel':
        data = (
          <>
            { noParcel ? null : (
              <>
                Parcel Id: {queryData ? queryData.id : null}
                <br/>
                Owner: {queryData.attributes['Owner Name 1']}
                <br/>
                Address: {queryData.attributes['Site Address 1']}
              </>
            )}
          </>
        );
        break;
      case 'school-districts':  // fall through on purpose
      case 'zoning':
        data =(
          <>
            <Table>
            {Object.keys(queryData.attributes).map((key) => {
              return (
                <TableRow key={key}>
                  <TableCell>
                    {key}:
                  </TableCell>
                  <div style={{display: 'table-cell', minWidth: '1em'}} />
                  <TableCell>
                  {queryData.attributes[key]}
                  </TableCell>
                </TableRow>
              );
            })}
            </Table>
          </>
        );
        break;
      default:
      data = null;
    }
  }
  return (
    <Container>
      <div style={{flex: 1}}>
        <Location
          coordinates={coordinates}
          mapUnits={mapUnits}
        />
        {data}
        <br/>
        <div style={{textAlign: 'center'}}>
          <BlueSpan onClick={onMoreClick}>-more-</BlueSpan>
        </div>
      </div>
      <IconContainer>
        <SaveIcon onClick={saveClickHandler} />
        <CogIcon onClick={onSettingsClick}/>
      </IconContainer>
    </Container>
  );
}
